import Vue from 'vue'
import toast from './Toast.vue'

let ToastConstructor = Vue.extend(toast)

const selefToast = function (params) {
  const { text, type, mask, time } = params
  if (!text && !type && !mask) {
    return
  }
  if (JSON.stringify(document.getElementById('selef_toast')) === 'null') {
    let toastDom = new ToastConstructor({
      el: document.createElement('div')
    })
    document.body.appendChild(toastDom.$el)
    toastDom.text = text
    toastDom.type = type || 'success'
    toastDom.mask = mask || false
    if ((text || type || mask) && !toastDom.visible) {
      toastDom.visible = true
    }
    setTimeout(() => {
      toastDom.visible = false
      document.body.removeChild(toastDom.$el)
    }, time || 3000)
  }
}

export default selefToast
